import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IDtoDemand } from 'app/shared/models/legal/demand/dto-demand.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoConciliatoryAppointmentBoard } from 'app/shared/models/legal/demand/dto-conciliatory-appointment.model';
import { IDtoReceptionDemand } from 'app/shared/models/legal/demand/dto-reception-demand.model';
import { IDtoAnswerDemand } from 'app/shared/models/legal/demand/dto-answer-demand.model';
import { IDtoOfferAdmissionEvidence } from 'app/shared/models/legal/demand/offer-admission-evidence.model';
import { IDtoOfferAdmissionEvidenceDetail } from 'app/shared/models/legal/demand/offer-admission-evidence-detail.model';
import { IDtoReleaseEvidence } from 'app/shared/models/legal/demand/release-evidence.model';
import { IDtoAllegation } from 'app/shared/models/legal/demand/dto-allegation.model';
import { IDtoLaudo } from 'app/shared/models/legal/demand/dto-laudo.model';
import { IDtoConciliatoryAppointmentCourt } from 'app/shared/models/legal/demand/dto-conciliatory-appointment-court.model';
import { IDtoPreliminaryAudience } from 'app/shared/models/legal/demand/dto-preliminary-audience.model';
import { IDtoPreliminaryAudienceEvidenceDetail } from 'app/shared/models/legal/demand/dto-preliminary-audience-evidence-detail.model';
import { IDtoJudgmentAudience } from 'app/shared/models/legal/demand/dto-judgment-audience.model';
import { IDtoLawyer } from 'app/shared/models/legal/dto-lawyer.model';
@Injectable()
export class DemandService {
  private concludeDemandSource = new Subject<boolean>();
  concludeDemandChallenge$ = this.concludeDemandSource.asObservable();
  private currentStepSource = new Subject<number>();
  currentStepChallenge$ = this.currentStepSource.asObservable();
  private documentNumberSource = new Subject<string>();
  documentNumberChallenge$ = this.documentNumberSource.asObservable();
  private requestUrl = '';
  constructor(private service: DataService, private configurationService: ConfigurationService) {
    if (this.configurationService.isReady) {
      this.requestUrl = this.configurationService.serverSettings.requestUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.requestUrl = this.configurationService.serverSettings.requestUrl;
      });
    }
  }
  private demandStates: IDtoCatalog[] = [
    { id: 1, name: 'Proceso demanda', additional: 'Etapa 1' },
    { id: 2, name: 'Cita conciliatoria', additional: 'Etapa 1' },
    { id: 3, name: 'Recepción de la demanda', additional: 'Etapa 1' },
    { id: 4, name: 'Contestación de la demanda', additional: 'Etapa 1' },
    { id: 5, name: 'Ofrecimiento y admisión de pruebas', additional: 'Etapa 1' },
    { id: 6, name: 'Audiencia desahogo de pruebas', additional: 'Etapa 1' },
    { id: 7, name: 'Alegatos', additional: 'Etapa 1' },
    { id: 8, name: 'Laudos', additional: 'Etapa 1' },
    { id: 9, name: 'Costo demanda', additional: 'Etapa 1' },
    { id: 10, name: 'Cita conciliatoria', additional: 'Etapa 2' },
    { id: 11, name: 'Audiencia preliminar', additional: 'Etapa 2' },
    { id: 12, name: 'Audiencia de juicio', additional: 'Etapa 2' },
    { id: 13, name: 'Laudos', additional: 'Etapa 2' },
    { id: 14, name: 'Costo demanda', additional: 'Etapa 2' }
  ];
  public getCatalogDemandStates(): Observable<IDtoCatalog[]> {
    return Observable.of(this.demandStates);
  }
  public getCatalogLawyers(): Observable<IDtoCatalog[]> {
    const url = this.requestUrl + 'api/Lawyers/getCatalogLawyers';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogAuthorities(): Observable<IDtoCatalog[]> {
    const url = this.requestUrl + 'api/Authorities/getCatalogAuthorities';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogTypeConciliationMeetings(): Observable<IDtoCatalog[]> {
    const url = this.requestUrl + 'api/TypeConciliationMeetings/getCatalogTypeConciliationMeetings';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogProceduralStages(type: string): Observable<IDtoCatalog[]> {
    const url = `${this.requestUrl}api/ProceduralStages/getCatalogProceduralStages?type=${type}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addDemand(data: IDtoDemand): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addDemand`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public getDemandByliquidationId(liquidationId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/getDemandByliquidationId?liquidationId=${liquidationId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addConciliatoryAppointmentBoard(data: IDtoConciliatoryAppointmentBoard): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addConciliatoryAppointmentBoard`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateConciliatoryAppointmentBoard(data: IDtoConciliatoryAppointmentBoard): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateConciliatoryAppointmentBoard`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addReceptionDemand(data: IDtoReceptionDemand): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addReceptionDemand`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateReceptionDemand(data: IDtoReceptionDemand): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateReceptionDemand`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addAnswerDemand(data: IDtoAnswerDemand): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addAnswerDemand`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateAnswerDemand(data: IDtoAnswerDemand): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateAnswerDemand`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public getCatalogTypeTests(): Observable<IDtoCatalog[]> {
    const url = this.requestUrl + 'api/Demands/getCatalogTypeTests';
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addOfferAdmissionEvidence(data: IDtoOfferAdmissionEvidence): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addOfferAdmissionEvidence`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateOfferAdmissionEvidence(data: IDtoOfferAdmissionEvidence): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateOfferAdmissionEvidence`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public getOfferAdmissionEvidenceDetailByOfferAdmissionEvidenceId(offerAdmissionEvidenceId: number): Observable<IDtoOfferAdmissionEvidenceDetail[]> {
    const url = `${this.requestUrl}api/Demands/getOfferAdmissionEvidenceDetailByOfferAdmissionEvidenceId?offerAdmissionEvidenceId=${offerAdmissionEvidenceId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addOfferAdmissionEvidenceDetail(data: IDtoOfferAdmissionEvidenceDetail): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addOfferAdmissionEvidenceDetail`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public deleteDetailEvidence(id: Number): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/deleteDetailEvidence?id=${id}`;

    return this.service.delete(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateOfferAdmissionEvidenceDetail(data: IDtoOfferAdmissionEvidenceDetail): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateOfferAdmissionEvidenceDetail`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addReleaseEvidence(data: IDtoReleaseEvidence): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addReleaseEvidence`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateReleaseEvidence(data: IDtoReleaseEvidence): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateReleaseEvidence`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addAllegation(data: IDtoAllegation): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addAllegation`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateAllegation(data: IDtoAllegation): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateAllegation`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addLaudo(data: IDtoLaudo): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addLaudo`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateLaudo(data: IDtoLaudo): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateLaudo`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addConciliatoryAppointmentCourt(data: IDtoConciliatoryAppointmentCourt): Observable<IResult> {
    const url = `${this.requestUrl}api/ConciliatoryAppointmentCourts/addConciliatoryAppointmentCourt`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateConciliatoryAppointmentCourt(data: IDtoConciliatoryAppointmentCourt): Observable<IResult> {
    const url = `${this.requestUrl}api/ConciliatoryAppointmentCourts/updateConciliatoryAppointmentCourt`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addPreliminaryAudience(data: IDtoPreliminaryAudience): Observable<IResult> {
    const url = `${this.requestUrl}api/PreliminaryAudiences/addPreliminaryAudience`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updatePreliminaryAudience(data: IDtoPreliminaryAudience): Observable<IResult> {
    const url = `${this.requestUrl}api/PreliminaryAudiences/updatePreliminaryAudience`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public getPreliminaryAudienceEvidenceDetailByPreliminaryAudienceId(preliminaryAudienceId: number): Observable<IDtoPreliminaryAudienceEvidenceDetail[]> {
    const url = `${this.requestUrl}api/PreliminaryAudienceEvidenceDetails/getPreliminaryAudienceEvidenceDetailByPreliminaryAudienceId?preliminaryAudienceId=${preliminaryAudienceId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addPreliminaryAudienceEvidenceDetail(data: IDtoPreliminaryAudienceEvidenceDetail): Observable<IResult> {
    const url = `${this.requestUrl}api/PreliminaryAudienceEvidenceDetails/addPreliminaryAudienceEvidenceDetail`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public deletePreliminaryAudienceEvidenceDetail(id: Number): Observable<IResult> {
    const url = `${this.requestUrl}api/PreliminaryAudienceEvidenceDetails/deletePreliminaryAudienceEvidenceDetail?id=${id}`;

    return this.service.delete(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public getPreliminaryAudienceEvidenceDetails(preliminaryAudienceId: number): Observable<IDtoPreliminaryAudienceEvidenceDetail[]> {
    const url = `${this.requestUrl}api/PreliminaryAudienceEvidenceDetails/getPreliminaryAudienceEvidenceDetails?preliminaryAudienceId=${preliminaryAudienceId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public updatePreliminaryAudienceEvidenceDetail(data: IDtoPreliminaryAudienceEvidenceDetail): Observable<IResult> {
    const url = `${this.requestUrl}api/PreliminaryAudienceEvidenceDetails/updatePreliminaryAudienceEvidenceDetail`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public addJudgmentAudience(data: IDtoJudgmentAudience): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/addJudgmentAudience`;
    return this.service.post(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public updateJudgmentAudience(data: IDtoJudgmentAudience): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/updateJudgmentAudience`;
    return this.service.putWithId(url, data).pipe(map((response: any) => {
      return response;
    }));
  }
  public restartProceduralStages(liquidationId: number, stage: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/restartProceduralStages?liquidationId=${liquidationId}&stage=${stage}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public concludeDemand(conclude: boolean) {
    this.concludeDemandSource.next(conclude);
  }
  public currentStep(step: number) {
    this.currentStepSource.next(step);
  }
  public documentNumber(document: string) {
    this.documentNumberSource.next(document);
  }
  public getEstimatedCostProceduralStagesByAuthorityAndLawyer(authorityId: number, lawyerId: number, liquidationId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Lawyers/getEstimatedCostProceduralStagesByAuthorityAndLawyer?authorityId=${authorityId}&lawyerId=${lawyerId}&liquidationId=${liquidationId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getDemandBasicByliquidationId(liquidationId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/getDemandBasicByliquidationId?liquidationId=${liquidationId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCostProceduralStagesByAuthorityAndLawyer(authorityId: number, lawyerId: number, liquidationId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Lawyers/getCostProceduralStagesByAuthorityAndLawyer?authorityId=${authorityId}&lawyerId=${lawyerId}&liquidationId=${liquidationId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getDemandsByStatusId(statusId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Demands/getDemandsByStatusId?statusId=${statusId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getLawyerById(lawyerId: number): Observable<IDtoLawyer> {
    const url = `${this.requestUrl}api/Lawyers/getLawyerById?lawyerId=${lawyerId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public generateLockSaved(stepDemand: number, step: number): boolean {
          let diff = stepDemand - step;
          if (diff > 0) {
             return true;
          } else {
              return false;
          }
      }
}
